// Popup "Te llamamos": fija el tag correcto (callme / callmepdp) según el botón pulsado,
// combina prefijo + número de teléfono en el campo oculto contact[phone], envía el lead a
// Klaviyo (endpoint público /client/subscriptions) sin bloquear el envío nativo a Shopify,
// y reabre el popup tras el envío del formulario para mostrar el mensaje de éxito/error.
(function () {
  var popup = document.getElementById('CallMePopup');
  if (!popup) return;

  var tagField = popup.querySelector('[data-callme-tag-field]');
  var phonePrefix = popup.querySelector('#CallMePhonePrefix');
  var phoneNumber = popup.querySelector('#CallMePhoneNumber');
  var phoneHidden = popup.querySelector('#CallMePhoneHidden');
  var phoneHiddenCustomer = popup.querySelector('#CallMePhoneHiddenCustomer');
  var nameField = popup.querySelector('#CallMeName');
  var emailField = popup.querySelector('#CallMeEmail');
  var noteField = popup.querySelector('#CallMeNoteField');
  var klaviyoCompanyIdField = popup.querySelector('#CallMeKlaviyoCompanyId');
  var klaviyoListIdField = popup.querySelector('#CallMeKlaviyoListId');

  function updateHiddenPhone() {
    if (!phoneHidden) return;
    var prefix = phonePrefix ? phonePrefix.value : '';
    var number = phoneNumber ? phoneNumber.value.replace(/[^\d]/g, '') : '';
    var full = number ? prefix + number : '';
    phoneHidden.value = full;
    if (phoneHiddenCustomer) phoneHiddenCustomer.value = full;

    // contact[phone] / customer[phone] no se guardan de forma fiable en el customer (ver
    // comentario en callme-popup.liquid) — se repite el teléfono en la nota como respaldo
    // garantizado.
    if (noteField) {
      var baseNote = noteField.getAttribute('data-base-note') || '';
      noteField.value = full ? 'Teléfono: ' + full + ' · ' + baseNote : baseNote;
    }
  }

  if (phonePrefix) phonePrefix.addEventListener('change', updateHiddenPhone);
  if (phoneNumber) phoneNumber.addEventListener('input', updateHiddenPhone);

  function sendToKlaviyo() {
    var companyId = klaviyoCompanyIdField ? klaviyoCompanyIdField.value.trim() : '';
    var listId = klaviyoListIdField ? klaviyoListIdField.value.trim() : '';
    var email = emailField ? emailField.value.trim() : '';
    if (!companyId || !listId || !email) return;

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Popup Te llamamos (' + (tagField ? tagField.value : 'callme') + ')',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                phone_number: phoneHidden ? phoneHidden.value : '',
                first_name: nameField ? nameField.value.trim() : '',
                subscriptions: {
                  email: { marketing: { consent: 'SUBSCRIBED' } },
                  sms: { marketing: { consent: 'SUBSCRIBED' } }
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: '2025-07-15'
      },
      body: JSON.stringify(body),
      keepalive: true
    }).catch(function () {
      // Silencioso: si Klaviyo falla, el lead ya se ha guardado como customer en Shopify.
    });
  }

  var form = popup.querySelector('#CallMeForm');
  if (form) {
    form.addEventListener('submit', function () {
      updateHiddenPhone();
      sendToKlaviyo();
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-callme-trigger]');
    if (!trigger) return;
    if (tagField) tagField.value = trigger.getAttribute('data-callme-tag') || 'callme';
    popup.show(trigger);
  });

  // ModalDialog.hide() (global.js) dispara "modalClosed" en <body> al cerrarse, por
  // cualquiera de las 3 vías (botón, Escape, clic fuera). Al cerrar, se limpia el formulario:
  // si no, al reabrirlo (sin recargar la página) seguiría el checkbox marcado y el mensaje
  // de "¡Gracias!" de un envío anterior.
  document.body.addEventListener('modalClosed', function () {
    if (form) form.reset();
    var success = popup.querySelector('.callme-popup__success');
    if (success) success.remove();
    var errors = popup.querySelector('.callme-popup__errors');
    if (errors) errors.remove();
    updateHiddenPhone();
  });

  // Tras un envío normal (sin JS de por medio), Shopify recarga la página con el resultado
  // del formulario. Si hay mensaje de éxito o error dentro del popup, lo reabrimos para que
  // se vea (si no, quedaría oculto detrás del modal cerrado).
  if (popup.querySelector('[data-callme-status]') || popup.querySelector('.callme-popup__errors')) {
    popup.show();
  }
})();
